<user-navigation></user-navigation>

<div class="container-fluid">
  <div id="top"></div>
    <div class="row no-gutter">
        <div class="col-md-12 col-lg-4 profile-side-bar">
            <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mb-5 mb-md-0">
                            <div id="page-redirection">
                                <a routerLink="/user/profile">
                                    <img src="../../../../assets/images/arrows/back_arrow.png">
                                    Back to Account
                                </a>
                            </div>
                            <h3 class="display-4 box-title mt-4 mt-md-4">Replace Breathing Device</h3><br>
                            <div class="alert alert-success alert-dismissible fade show" role="success" *ngIf="success">
                              <button type="button" class="close" data-dismiss="alert">&times;</button>
                              Successfully requested a breathing device.
                            </div>
                            <form action="#">
                                <div class="payment-method-update mt-md-5 mt-5">
                                    <label class="font-weight-bold summary-title">Delivery Address</label>
                                    <a href="/user/delivery-address" class="pull-right font-weight-bold change-link">Change</a>

                                    <p class="font-weight-normal mb-md-0 mb-0">
                                      {{ deliveryAddress }}
                                    </p>
                                </div>
                                <div class="payment-method-update mt-md-5 mt-5" *ngIf="hasPaymentMethod">
                                    <label class="font-weight-bold summary-title">Payment Method</label>
                                    <a href="/user/payment-method" class="pull-right font-weight-bold change-link">Change</a><br>

                                    <label class="font-weight-bold mb-md-0 mb-0">Card</label>
                                    <p class="font-weight-bold card-details">**** **** **** {{lastFourDigits}} <span class="pull-right">{{expireMonth}}/{{expireYear}}</span></p>
                                    <div class="border-line mb-md-5 mb-5"></div>
                                </div>

                                <div class="breathing-summary mb-md-4 mb-4 col-md-12">
                                    <div class="row mb-md-2 mb-2">
                                        <div class="col-md-6 px-md-4 px-5 text-right text-md-left"><span class="font-weight-bold">Breathing Device</span></div>
                                        <div class="col-md-6 px-md-4 px-5"><span class="pull-right">NZD ${{ device_price }}</span></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 px-md-4 px-5">
                                          <!--
                                          <input type="number" min="1" required (input)="computeTotal($event)" value=1 class="col-md-4 form-control form-control-sm text-center">
                                          -->
                                          <span class="d-none d-md-block">1</span>
                                        </div>
                                        <div class="col-md-6 px-md-4 px-5">
                                          <span class="pull-right font-weight-bold text-wrap">Subtotal: NZD ${{ device_price }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="delivery-summary mb-md-5 mb-5 col-md-12">
                                    <div class="row mb-md-2 mb-2">
                                        <div class="col-md-12 px-md-4 px-5"><span class="pull-right">Delivery Fee: +NZD ${{ delivery_charge }}</span></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 px-md-4 px-5"><span class="pull-right font-weight-bold text-wrap">Total: NZD ${{total}}</span></div>
                                    </div>
                                </div>
                                <button type="button" (click)="resetForm()" data-toggle="modal" data-target="#cancelModalCenter" class="btn btn-primary btn-block btn-submit">Purchase
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>

<footer-main></footer-main>

<!-- Modal -->
<div class="modal fade" id="cancelModalCenter" tabindex="-1" role="dialog" aria-labelledby="cancelModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="cancelModalTitle">Replace Device</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="passwordForm" (ngSubmit)="onPurchase()">
        <div class="modal-body">
          <div class="alert alert-danger alert-dismissible fade show" *ngIf="pending_request_error">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            {{ errorMsg }}
          </div>
          Please enter your password below to continue.
          <input  type="password" formControlName="password" class="form-control mt-3" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Enter password">
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required</div>
            <div *ngIf="f.password.errors.invalid">Password is incorrect</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="pull-right btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
          <button type="submit" class="pull-right btn btn-primary btn-sm" [disabled]="loading">
            Purchase
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

